import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, XAxis } from 'recharts'
import { useSettingsStore } from '@/state/useSettingsStore'
import { formatCzkShort } from '@/lib/format'

interface Props {
  data: Array<{ t: string; income: number; expense: number; net: number }>
  height?: number
}

/**
 * Příjem z banky po měsících. Peníze chodí souhrnně jednou měsíčně
 * (výplata ze Stripu), takže denní křivka by byla rovná čára s jedním
 * schodem — sloupec na měsíc říká totéž a čte se na dálku líp.
 */
export function RevenueMonthlyBars({ data, height = 220 }: Props) {
  const locale = useSettingsStore((s) => s.locale)

  if (data.length === 0) {
    return (
      <div className="grid text-sm text-ink-subtle" style={{ height, placeItems: 'center' }}>
        —
      </div>
    )
  }

  const rows = data.map((d) => {
    const date = new Date(d.t)
    return {
      label: date.toLocaleDateString(locale === 'cs' ? 'cs-CZ' : 'en-GB', {
        month: 'short',
        year: '2-digit',
      }),
      value: d.income,
    }
  })

  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={rows} margin={{ top: 22, right: 8, bottom: 0, left: 8 }}>
        <CartesianGrid vertical={false} stroke="var(--border)" strokeDasharray="3 3" />
        <XAxis
          dataKey="label"
          tickLine={false}
          axisLine={false}
          tick={{ fill: 'var(--ink-subtle)', fontSize: 12 }}
        />
        <Bar dataKey="value" radius={[8, 8, 0, 0]} isAnimationActive={false} maxBarSize={72}>
          {rows.map((_, i) => (
            <Cell key={i} fill="var(--brand-primary)" />
          ))}
          {/* Částka nad sloupcem — na televizi si nikdo nenajede myší. */}
          <LabelList
            dataKey="value"
            position="top"
            formatter={(v: number) => formatCzkShort(v, locale)}
            style={{ fill: 'var(--ink)', fontSize: 13, fontWeight: 600 }}
          />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  )
}
